import React from 'react';

const ItemForm2 = (props) => {
    return (
        <>
            <div className="item-grp flex gap-2.5 mb-3 mt-3">
                <div className="input-grp w-full">
                    <label>Remarks</label>
                    <input
                        type="text"
                        id="remarks"
                        name="remarks"
                        autocomplete="off"
                        value={props.invoiceDetails.remarks}
                        onChange={(event) =>
                            props.handleChange(event, "remarks", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp min-w-[15%]">
                    <label>Freight (+)</label>
                    <input
                        type="number"
                        id="freight"
                        name="freight"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.freight}
                        onChange={(event) =>
                            props.handleChange(event, "freight", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp min-w-[15%]">
                    <label>Other (+)</label>
                    <input
                        type="number"
                        id="other"
                        name="other"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.other}
                        onChange={(event) =>
                            props.handleChange(event, "other", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp min-w-[15%]">
                    <label>Round Off</label>
                    <input
                        type="number"
                        id="roundOff"
                        name="roundOff"
                        className="inputFocus w-full"
                        autocomplete="off"
                        disabled
                        value={props.invoiceDetails.roundOff}
                        onChange={(event) =>
                            props.handleChange(event, "roundOff", "invoiceDetails")
                        }
                    />
                </div>
            </div>



        </>
    );
};

export default ItemForm2;